import Vue from 'vue'
import Vuex from 'vuex'
// import * as getters from './getters'
// import * as actions from './actions'
import auth from './modules/auth'
import profile from './modules/profile'
import ui from './modules/ui'
import decoder from './modules/decoder'
import branding from './modules/branding'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    auth,
    profile,
    ui,
    decoder,
    branding
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js